import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import InputType from '@linc-technologies/linced-common/enums/input-type';

export default class Field extends RESTSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    optionSetIds: { serialize: 'ids' },
  };

  payloadKeyFromModelName(modelName) {
    return modelName.replace(/^school-options\/field/, 'option');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace(/^option/, 'school-options/field'),
    );
  }

  normalize(model, hash, prop) {
    let defaults = {
      sequence: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }

  serializeIntoHash(hash) {
    super.serializeIntoHash(...arguments);
    let dataType = 0;
    switch (hash.option.inputType) {
      case InputType.CHECKBOX:
      case InputType.MULTI_SELECT:
      case InputType.SORTABLE_LIST:
        dataType = DataType.LIST;
        break;
      case InputType.NUMBER:
        // Already set via the UI.
        dataType = hash.option.dataType;
        break;
      case InputType.SWITCH:
        dataType = DataType.BOOLEAN;
        break;
      case InputType.SELECT:
        dataType = hash.option.dataType || DataType.STRING;
        break;
      case InputType.EDITABLE_LIST:
        dataType = DataType.VALUE_LIST;
        break;
      default:
        dataType = DataType.STRING;
        break;
    }
    hash.option.dataType = dataType;
  }
}
